import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/channels",
	lazy(() => import("./AdminChannelsDashboardPage"))
);
